angular.module 'zc.core'

.directive 'zcDateRange', ($filter) ->
  restrict: "E"
  scope:
    startAt: '='
    endAt: '='
    isInfinite: '='
    displayTime: '='
  template: """
    {{ startAt | zcDate: { smart: isUseSmart, dateOnly: !displayTime } }}
    -
    {{ isInfinite
      ? ('projectsCampaignsViews.directives.campaignRange.kigen_nashi' | translate)
      : ( endAt | zcDate: { smart: isUseSmart, dateOnly: !displayTime } ) }}
  """
  link: (scope) ->
    scope.isUseSmart = moment(scope.startAt).isSame(moment(scope.endAt), 'year')



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/date_range.directive.coffee